import { useTracking } from '@/contexts/tracking-context'
import { useWorkflow } from '@/context/workflow-context-simple'

export const useWorkflowTracking = () => {
  const { track } = useTracking()
  const { currentStage, currentView } = useWorkflow()

  const trackWorkflowEvent = (eventName: string, properties?: any) => {
    track({
      name: eventName,
      properties: {
        stage: currentStage,
        viewId: currentView?.viewSettingsId,
        viewTitle: currentView?.title,
        ...properties,
      },
    })
  }

  const trackStageChange = (fromStage: string, toStage: string) => {
    trackWorkflowEvent('Click Tracking', {
      action: 'stage_changed',
      fromStage,
      toStage,
    })
  }

  const trackCellAction = (action: 'show' | 'hide' | 'reorder' | 'edit' | 'delete', columnName: string) => {
    trackWorkflowEvent('Click Tracking', {
      action: 'cell_action_' + action,
      columnName,
    })
  }

  const trackColumnAction = (action: 'show' | 'hide' | 'reorder' | 'edit' | 'delete', columnName: string) => {
    trackWorkflowEvent('Click Tracking', {
      action: 'column_action_' + action,
      columnName,
    })
  }

  const trackFilterAction = (action: 'apply' | 'clear' | 'modify', filterType: string, filterValue?: any) => {
    trackWorkflowEvent('Click Tracking', {
      action: 'filter_action_' + action,
      filterType,
      filterValue,
    })
  }

  const trackViewAction = (action: 'create' | 'save' | 'load' | 'delete' | 'edit', viewTitle?: string) => {
    trackWorkflowEvent('Click Tracking', {
      action: 'view_action_' + action,
      viewTitle,
    })
  }

  const trackGridAction = (action: 'sort' | 'page' | 'search', properties?: any) => {
    trackWorkflowEvent('Click Tracking', {
      action: 'grid_action_' + action,
      ...properties,
    })
  }

  const trackCustomColumnAction = (action: 'create' | 'edit' | 'delete', columnType?: string) => {
    trackWorkflowEvent('Click Tracking', {
      action: 'custom_column_action_' + action,
      columnType,
    })
  }

  return {
    trackWorkflowEvent,
    trackStageChange,
    trackColumnAction,
    trackCellAction,
    trackFilterAction,
    trackViewAction,
    trackGridAction,
    trackCustomColumnAction,
  }
} 